// AUTO-GENERATED by scripts/gen-voice.py - do not edit by hand.
export interface VoiceLine {
  id: string;
  category: string;
  voice: string;
  text: string;
  file: string;
}

export const VOICE_LINES: VoiceLine[] = [
  {
    "id": "welcome_1",
    "category": "welcome",
    "voice": "Mia",
    "text": "Welcome back, Commander. The mesh is restless. Select a mission and deploy when you are ready.",
    "file": "welcome_1.mp3"
  },
  {
    "id": "welcome_2",
    "category": "welcome",
    "voice": "Mia",
    "text": "Aegis Response Command online. All systems nominal. Awaiting your orders.",
    "file": "welcome_2.mp3"
  },
  {
    "id": "welcome_3",
    "category": "welcome",
    "voice": "Mia",
    "text": "Command deck is ready, Commander. Review the field manual if you need a refresher.",
    "file": "welcome_3.mp3"
  },
  {
    "id": "tutorial_1",
    "category": "tutorial",
    "voice": "Mia",
    "text": "Press one through eight to select a tower, then click a pad to build it.",
    "file": "tutorial_1.mp3"
  },
  {
    "id": "tutorial_2",
    "category": "tutorial",
    "voice": "Mia",
    "text": "Press space to call the next wave. Calling it early grants bonus supply.",
    "file": "tutorial_2.mp3"
  },
  {
    "id": "tutorial_3",
    "category": "tutorial",
    "voice": "Mia",
    "text": "Click any tower to open its upgrade, priority, evolution and symbiosis menu.",
    "file": "tutorial_3.mp3"
  },
  {
    "id": "mission_kappa",
    "category": "mission",
    "voice": "Dean",
    "text": "Outpost Kappa. Undermesh activity is spiking beneath the geothermal plant. Hold Bastion Seven until orbital lift clears the reactor core.",
    "file": "mission_kappa.mp3"
  },
  {
    "id": "mission_helios",
    "category": "mission",
    "voice": "Dean",
    "text": "Helios Drift. Mesh signals are waking the lower labs. Hold the surface relay at all costs.",
    "file": "mission_helios.mp3"
  },
  {
    "id": "mission_cinder",
    "category": "mission",
    "voice": "Dean",
    "text": "Cinder Reach. Mesh borers are chewing through the lower catwalks. Keep the slag refineries secure.",
    "file": "mission_cinder.mp3"
  },
  {
    "id": "mission_meridian",
    "category": "mission",
    "voice": "Dean",
    "text": "Meridian Spire. A mesh root system is climbing the foundation pylons. Protect the mass driver.",
    "file": "mission_meridian.mp3"
  },
  {
    "id": "mission_ashfall",
    "category": "mission",
    "voice": "Dean",
    "text": "Ashfall Terminal. Mesh elites are probing the perimeter every wave. Hold the evacuation hub.",
    "file": "mission_ashfall.mp3"
  },
  {
    "id": "mission_theta",
    "category": "mission",
    "voice": "Dean",
    "text": "Vault Theta. Subsurface reactor. Colossus-class signatures confirmed. This is a hard hold, Commander.",
    "file": "mission_theta.mp3"
  },
  {
    "id": "wave_1",
    "category": "wave",
    "voice": "Dean",
    "text": "Wave inbound. Hostiles entering the lane. Weapons free.",
    "file": "wave_1.mp3"
  },
  {
    "id": "wave_2",
    "category": "wave",
    "voice": "Dean",
    "text": "New contacts on the route. Stay sharp.",
    "file": "wave_2.mp3"
  },
  {
    "id": "wave_3",
    "category": "wave",
    "voice": "Dean",
    "text": "Enemy push detected. Hold your positions.",
    "file": "wave_3.mp3"
  },
  {
    "id": "wave_4",
    "category": "wave",
    "voice": "Dean",
    "text": "Multiple hostiles crossing the perimeter. Engage at will.",
    "file": "wave_4.mp3"
  },
  {
    "id": "wave_5",
    "category": "wave",
    "voice": "Dean",
    "text": "They are testing the line. Do not let them through.",
    "file": "wave_5.mp3"
  },
  {
    "id": "wave_6",
    "category": "wave",
    "voice": "Dean",
    "text": "Heavy traffic on the lane. Prioritise your targets.",
    "file": "wave_6.mp3"
  },
  {
    "id": "wave_7",
    "category": "wave",
    "voice": "Dean",
    "text": "The swarm is thickening. Conserve your supply.",
    "file": "wave_7.mp3"
  },
  {
    "id": "wave_8",
    "category": "wave",
    "voice": "Dean",
    "text": "Large formation approaching. Brace for contact.",
    "file": "wave_8.mp3"
  },
  {
    "id": "boss_1",
    "category": "boss",
    "voice": "Dean",
    "text": "Warning. Massive signature on approach. That is a Colossus-class. Concentrate all fire.",
    "file": "boss_1.mp3"
  },
  {
    "id": "boss_2",
    "category": "boss",
    "voice": "Dean",
    "text": "Elite contact inbound. Armour plating detected. Bring it down.",
    "file": "boss_2.mp3"
  },
  {
    "id": "boss_3",
    "category": "boss",
    "voice": "Dean",
    "text": "Command, we have a heavy. All towers, focus fire on the big one.",
    "file": "boss_3.mp3"
  },
  {
    "id": "boss_4",
    "category": "boss",
    "voice": "Dean",
    "text": "Boss signature confirmed. This is the one that breaks the line. Hold, Commander.",
    "file": "boss_4.mp3"
  },
  {
    "id": "integrity_1",
    "category": "integrity",
    "voice": "Mia",
    "text": "Integrity critical. The core cannot take much more.",
    "file": "integrity_1.mp3"
  },
  {
    "id": "integrity_2",
    "category": "integrity",
    "voice": "Mia",
    "text": "Warning. Command core integrity failing. Reinforce immediately.",
    "file": "integrity_2.mp3"
  },
  {
    "id": "integrity_3",
    "category": "integrity",
    "voice": "Mia",
    "text": "We are losing the base, Commander. Do something.",
    "file": "integrity_3.mp3"
  },
  {
    "id": "integrity_4",
    "category": "integrity",
    "voice": "Mia",
    "text": "Integrity below threshold. One more breach and we lose the site.",
    "file": "integrity_4.mp3"
  },
  {
    "id": "breach_1",
    "category": "breach",
    "voice": "Dean",
    "text": "They are through! Breach at the command core!",
    "file": "breach_1.mp3"
  },
  {
    "id": "breach_2",
    "category": "breach",
    "voice": "Dean",
    "text": "Base hit. Damage control, now!",
    "file": "breach_2.mp3"
  },
  {
    "id": "breach_3",
    "category": "breach",
    "voice": "Dean",
    "text": "Perimeter breached. Plug that gap!",
    "file": "breach_3.mp3"
  },
  {
    "id": "victory_1",
    "category": "victory",
    "voice": "Dean",
    "text": "Site held. Outstanding work, Commander. The colony stands.",
    "file": "victory_1.mp3"
  },
  {
    "id": "victory_2",
    "category": "victory",
    "voice": "Dean",
    "text": "All hostiles neutralised. That was a textbook defence.",
    "file": "victory_2.mp3"
  },
  {
    "id": "victory_3",
    "category": "victory",
    "voice": "Dean",
    "text": "Mission complete. The mesh is broken here. For now.",
    "file": "victory_3.mp3"
  },
  {
    "id": "victory_4",
    "category": "victory",
    "voice": "Dean",
    "text": "Sector secure. Command is proud of you, Commander.",
    "file": "victory_4.mp3"
  },
  {
    "id": "victory_5",
    "category": "victory",
    "voice": "Mia",
    "text": "They never had a chance. Well fought, Commander.",
    "file": "victory_5.mp3"
  },
  {
    "id": "victory_6",
    "category": "victory",
    "voice": "Dean",
    "text": "Mission complete. Completely complete. Sorry, Commander. The sector is secure.",
    "file": "victory_6.mp3"
  },
  {
    "id": "victory_7",
    "category": "victory",
    "voice": "Mia",
    "text": "Mission complete. Clean sweep, clean signal, clean exit. Outstanding work.",
    "file": "victory_7.mp3"
  },
  {
    "id": "defeat_1",
    "category": "defeat",
    "voice": "Dean",
    "text": "Command core lost. We are pulling out. Fall back.",
    "file": "defeat_1.mp3"
  },
  {
    "id": "defeat_2",
    "category": "defeat",
    "voice": "Dean",
    "text": "Site overrun. This one is on us, Commander. Regroup and try again.",
    "file": "defeat_2.mp3"
  },
  {
    "id": "defeat_3",
    "category": "defeat",
    "voice": "Mia",
    "text": "Defence failed. The colony is lost. Withdraw.",
    "file": "defeat_3.mp3"
  },
  {
    "id": "build_1",
    "category": "build",
    "voice": "Mia",
    "text": "Tower online.",
    "file": "build_1.mp3"
  },
  {
    "id": "build_2",
    "category": "build",
    "voice": "Mia",
    "text": "Construction complete. Emplacement active.",
    "file": "build_2.mp3"
  },
  {
    "id": "build_3",
    "category": "build",
    "voice": "Mia",
    "text": "New platform deployed.",
    "file": "build_3.mp3"
  },
  {
    "id": "build_4",
    "category": "build",
    "voice": "Mia",
    "text": "Turret planted. Orientation locked. It is pointing exactly where it should.",
    "file": "build_4.mp3"
  },
  {
    "id": "build_5",
    "category": "build",
    "voice": "Dean",
    "text": "Emplacement secured. New guns on the line.",
    "file": "build_5.mp3"
  },
  {
    "id": "upgrade_1",
    "category": "upgrade",
    "voice": "Mia",
    "text": "Upgrade installed. That should hurt more.",
    "file": "upgrade_1.mp3"
  },
  {
    "id": "upgrade_2",
    "category": "upgrade",
    "voice": "Mia",
    "text": "Systems upgraded. Weapons hot.",
    "file": "upgrade_2.mp3"
  },
  {
    "id": "evolve_1",
    "category": "evolve",
    "voice": "Mia",
    "text": "Weapon evolution complete. New platform online.",
    "file": "evolve_1.mp3"
  },
  {
    "id": "evolve_2",
    "category": "evolve",
    "voice": "Mia",
    "text": "Evolution successful. That is a different beast now.",
    "file": "evolve_2.mp3"
  },
  {
    "id": "symbiosis_1",
    "category": "symbiosis",
    "voice": "Mia",
    "text": "Symbiosis module bolted on. Secondary weapon ready.",
    "file": "symbiosis_1.mp3"
  },
  {
    "id": "symbiosis_2",
    "category": "symbiosis",
    "voice": "Mia",
    "text": "Bolt-on installed. Additional firepower online.",
    "file": "symbiosis_2.mp3"
  },
  {
    "id": "ability_spear",
    "category": "ability",
    "voice": "Dean",
    "text": "Spear inbound. Danger close.",
    "file": "ability_spear.mp3"
  },
  {
    "id": "ability_barrier",
    "category": "ability",
    "voice": "Mia",
    "text": "Hardlight barrier deployed.",
    "file": "ability_barrier.mp3"
  },
  {
    "id": "ability_emp",
    "category": "ability",
    "voice": "Mia",
    "text": "EMP lance fired. Their systems are down.",
    "file": "ability_emp.mp3"
  },
  {
    "id": "ability_drone",
    "category": "ability",
    "voice": "Mia",
    "text": "Kite Three repositioned.",
    "file": "ability_drone.mp3"
  },
  {
    "id": "drone_attack",
    "category": "drone",
    "voice": "Mia",
    "text": "Kite Three switching to attack.",
    "file": "drone_attack.mp3"
  },
  {
    "id": "drone_boost",
    "category": "drone",
    "voice": "Mia",
    "text": "Kite Three boosting tower output.",
    "file": "drone_boost.mp3"
  },
  {
    "id": "drone_shield",
    "category": "drone",
    "voice": "Mia",
    "text": "Kite Three projecting shields.",
    "file": "drone_shield.mp3"
  },
  {
    "id": "firstblood_1",
    "category": "firstblood",
    "voice": "Dean",
    "text": "First blood. Good. Keep that pace.",
    "file": "firstblood_1.mp3"
  },
  {
    "id": "firstblood_2",
    "category": "firstblood",
    "voice": "Mia",
    "text": "Contact down. The line is holding.",
    "file": "firstblood_2.mp3"
  },
  {
    "id": "bossdown_1",
    "category": "bossdown",
    "voice": "Dean",
    "text": "Colossus down! Outstanding shooting, Commander. The line holds.",
    "file": "bossdown_1.mp3"
  },
  {
    "id": "bossdown_2",
    "category": "bossdown",
    "voice": "Dean",
    "text": "Boss neutralised. Whatever that thing was, it is scrap now.",
    "file": "bossdown_2.mp3"
  },
  {
    "id": "bossdown_3",
    "category": "bossdown",
    "voice": "Dean",
    "text": "Target destroyed. That was the heavy. The rest are just stragglers.",
    "file": "bossdown_3.mp3"
  },
  {
    "id": "elitedown_1",
    "category": "elitedown",
    "voice": "Mia",
    "text": "Elite neutralised. Threat level dropping.",
    "file": "elitedown_1.mp3"
  },
  {
    "id": "elitedown_2",
    "category": "elitedown",
    "voice": "Mia",
    "text": "Heavy contact down. Nice work, Commander.",
    "file": "elitedown_2.mp3"
  },
  {
    "id": "neardeath_1",
    "category": "neardeath",
    "voice": "Mia",
    "text": "Integrity critical! One more hit and the core goes. This is it, Commander!",
    "file": "neardeath_1.mp3"
  },
  {
    "id": "neardeath_2",
    "category": "neardeath",
    "voice": "Mia",
    "text": "We are one breach from total loss. Everything you have, now!",
    "file": "neardeath_2.mp3"
  },
  {
    "id": "neardeath_3",
    "category": "neardeath",
    "voice": "Dean",
    "text": "Core failing! Commander, if you have a play, make it now!",
    "file": "neardeath_3.mp3"
  },
  {
    "id": "waveclear_1",
    "category": "waveclear",
    "voice": "Mia",
    "text": "Wave cleared. Well done, Commander.",
    "file": "waveclear_1.mp3"
  },
  {
    "id": "waveclear_2",
    "category": "waveclear",
    "voice": "Mia",
    "text": "Sector quiet. Resupply and dig in.",
    "file": "waveclear_2.mp3"
  },
  {
    "id": "waveclear_3",
    "category": "waveclear",
    "voice": "Dean",
    "text": "Wave neutralised. They will be back, and bigger.",
    "file": "waveclear_3.mp3"
  },
  {
    "id": "perfect_1",
    "category": "perfect",
    "voice": "Dean",
    "text": "Flawless wave. Not a scratch on the core. Outstanding.",
    "file": "perfect_1.mp3"
  },
  {
    "id": "perfect_2",
    "category": "perfect",
    "voice": "Mia",
    "text": "Perfect defence, Commander. Command is impressed.",
    "file": "perfect_2.mp3"
  },
  {
    "id": "streak_1",
    "category": "streak",
    "voice": "Dean",
    "text": "That is a kill streak, Commander. The towers are singing.",
    "file": "streak_1.mp3"
  },
  {
    "id": "streak_2",
    "category": "streak",
    "voice": "Dean",
    "text": "They are dropping fast. Keep it up.",
    "file": "streak_2.mp3"
  },
  {
    "id": "lastwave_1",
    "category": "lastwave",
    "voice": "Dean",
    "text": "This is the final wave, Commander. Everything they have. Hold the line.",
    "file": "lastwave_1.mp3"
  },
  {
    "id": "lastwave_2",
    "category": "lastwave",
    "voice": "Dean",
    "text": "Last push incoming. Make it count.",
    "file": "lastwave_2.mp3"
  },
  {
    "id": "rush_single_1",
    "category": "rush_single",
    "voice": "Dean",
    "text": "Early wave rush confirmed. You called them into the crossfire.",
    "file": "rush_single_1.mp3"
  },
  {
    "id": "rush_single_2",
    "category": "rush_single",
    "voice": "Mia",
    "text": "Rush accepted. Two abreast on the lane. Let the turrets work.",
    "file": "rush_single_2.mp3"
  },
  {
    "id": "rush_double_1",
    "category": "rush_double",
    "voice": "Dean",
    "text": "Double rush! Four abreast and closing. Keep the guns cycling.",
    "file": "rush_double_1.mp3"
  },
  {
    "id": "rush_double_2",
    "category": "rush_double",
    "voice": "Mia",
    "text": "Second rush confirmed. The lane is crowded now. Hold your fire discipline.",
    "file": "rush_double_2.mp3"
  },
  {
    "id": "mayhem_1",
    "category": "mayhem",
    "voice": "Dean",
    "text": "Mayhem formation detected. Four abreast and moving fast. Make every shot count.",
    "file": "mayhem_1.mp3"
  },
  {
    "id": "mayhem_2",
    "category": "mayhem",
    "voice": "Mia",
    "text": "Four-wide contact! That is a lot of targets, Commander. Keep them off the core.",
    "file": "mayhem_2.mp3"
  },
  {
    "id": "maxed_1",
    "category": "maxed",
    "voice": "Mia",
    "text": "Tower at maximum output. It is a monster now.",
    "file": "maxed_1.mp3"
  },
  {
    "id": "maxed_2",
    "category": "maxed",
    "voice": "Mia",
    "text": "Full upgrade complete. That platform is fully online.",
    "file": "maxed_2.mp3"
  },
  {
    "id": "commendation_1",
    "category": "commendation",
    "voice": "Mia",
    "text": "Commendation earned, Commander. Well deserved.",
    "file": "commendation_1.mp3"
  },
  {
    "id": "achievement_first_blood",
    "category": "commendation",
    "voice": "Mia",
    "text": "Achievement unlocked: First Blood. Your opening strike is on the record, Commander.",
    "file": "achievement_first_blood.mp3"
  },
  {
    "id": "achievement_boss_slayer",
    "category": "commendation",
    "voice": "Dean",
    "text": "Achievement unlocked: Colossus Down. A heavy target erased by your command.",
    "file": "achievement_boss_slayer.mp3"
  },
  {
    "id": "achievement_perfect_kappa",
    "category": "commendation",
    "voice": "Mia",
    "text": "Achievement unlocked: Untouchable. The command core never took a scratch.",
    "file": "achievement_perfect_kappa.mp3"
  },
  {
    "id": "achievement_nightmare",
    "category": "commendation",
    "voice": "Dean",
    "text": "Achievement unlocked: No Exit. Nightmare protocol cleared. That is veteran work.",
    "file": "achievement_nightmare.mp3"
  },
  {
    "id": "achievement_generic",
    "category": "commendation",
    "voice": "Mia",
    "text": "Achievement earned, Commander. Your record just improved.",
    "file": "achievement_generic.mp3"
  },
  {
    "id": "resolution_1",
    "category": "resolution",
    "voice": "Dean",
    "text": "Threat resolved. The sector is yours, Commander.",
    "file": "resolution_1.mp3"
  },
  {
    "id": "resolution_2",
    "category": "resolution",
    "voice": "Mia",
    "text": "It is over. You held. Rest while you can.",
    "file": "resolution_2.mp3"
  },
  {
    "id": "story_intro_1",
    "category": "intro",
    "voice": "Dean",
    "text": "The colonies did not fall in a single night. The Undermesh woke beneath the last human lights. Bastion Seven is the last hold.",
    "file": "story_intro_1.mp3"
  },
  {
    "id": "story_intro_2",
    "category": "intro",
    "voice": "Mia",
    "text": "You command Bastion Seven. Build with purpose, read the lanes, and make every tower earn its place.",
    "file": "story_intro_2.mp3"
  },
  {
    "id": "story_intro_3",
    "category": "intro",
    "voice": "Dean",
    "text": "Campaign teaches. Research changes the odds. Survival never ends. Hold the core, Commander.",
    "file": "story_intro_3.mp3"
  },
  {
    "id": "research_bal_crit4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Kinetic Weakpoint. Ballistic fire now hunts the weak seam.",
    "file": "research_bal_crit4.mp3"
  },
  {
    "id": "research_bal_crit5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Deadeye Doctrine. Kestrel fire has become execution.",
    "file": "research_bal_crit5.mp3"
  },
  {
    "id": "research_th_splash4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Overheat Bloom. Thermal splash will spread farther.",
    "file": "research_th_splash4.mp3"
  },
  {
    "id": "research_th_splash5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Inferno Envelope. Pyre fire now owns the lane.",
    "file": "research_th_splash5.mp3"
  },
  {
    "id": "research_art_splash4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Breach Pattern. Mordant impacts will open a wider kill zone.",
    "file": "research_art_splash4.mp3"
  },
  {
    "id": "research_art_splash5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Barrage Doctrine. Mordant now speaks in shockwaves.",
    "file": "research_art_splash5.mp3"
  },
  {
    "id": "research_en_crit4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Pulse Fracture. Helios energy can now split the armour line.",
    "file": "research_en_crit4.mp3"
  },
  {
    "id": "research_en_crit5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Singularity Pulse. Helios has found the centre of the storm.",
    "file": "research_en_crit5.mp3"
  },
  {
    "id": "research_sym_overclock4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Symbiosis Overclock. Bolt-on weapons are running hotter.",
    "file": "research_sym_overclock4.mp3"
  },
  {
    "id": "research_sym_meld5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Unified Fire Control. Every secondary weapon now fires as one.",
    "file": "research_sym_meld5.mp3"
  },
  {
    "id": "research_rd_balls4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Bastion Magazine. Rolling Death carries a deeper reserve.",
    "file": "research_rd_balls4.mp3"
  },
  {
    "id": "research_rd_balls5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Storm Salvo. The bastion can now roll a full kinetic storm.",
    "file": "research_rd_balls5.mp3"
  },
  {
    "id": "research_orb_fire4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Sustained Wake. The orbital spear leaves the battlefield burning longer.",
    "file": "research_orb_fire4.mp3"
  },
  {
    "id": "research_orb_annihilation5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Annihilation Package. Orbital fire is cleared for total erasure.",
    "file": "research_orb_annihilation5.mp3"
  },
  {
    "id": "research_bar_hp4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Reactive Lattice. Hardlight will answer impact with strength.",
    "file": "research_bar_hp4.mp3"
  },
  {
    "id": "research_bar_recovery5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Emergency Reclaim. The barrier network can be rebuilt under fire.",
    "file": "research_bar_recovery5.mp3"
  },
  {
    "id": "research_cmd_integrity4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Deep Core Vault. Bastion Seven has another layer of life.",
    "file": "research_cmd_integrity4.mp3"
  },
  {
    "id": "research_cmd_supply5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Strategic Reserve. We can start the next hold with more in the magazine.",
    "file": "research_cmd_supply5.mp3"
  },
  {
    "id": "research_vul_crit4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Cyclone Shatter. The gatling is learning where armour breaks.",
    "file": "research_vul_crit4.mp3"
  },
  {
    "id": "research_vul_crit5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Storm Feed. Cyclone can now turn a lane into weather.",
    "file": "research_vul_crit5.mp3"
  },
  {
    "id": "research_sab_splash4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Saturation Warheads. Sabre salvos will land across a wider field.",
    "file": "research_sab_splash4.mp3"
  },
  {
    "id": "research_sab_splash5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Theatre Strike. Sabre has the whole approach in its sights.",
    "file": "research_sab_splash5.mp3"
  },
  {
    "id": "research_tes_chain4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Arc Cascade. Tesla has one more target in the chain.",
    "file": "research_tes_chain4.mp3"
  },
  {
    "id": "research_tes_chain5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Storm Lattice. Tesla can now own the entire cluster.",
    "file": "research_tes_chain5.mp3"
  },
  {
    "id": "research_cry_splash4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Flash Freeze. Cryo impact will lock a wider field.",
    "file": "research_cry_splash4.mp3"
  },
  {
    "id": "research_cry_splash5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Whiteout Field. Cryo is now the weather.",
    "file": "research_cry_splash5.mp3"
  },
  {
    "id": "research_sw_splash4",
    "category": "research",
    "voice": "Mia",
    "text": "Research complete: Cluster Swarm. Wasp drones will spread their strike pattern.",
    "file": "research_sw_splash4.mp3"
  },
  {
    "id": "research_sw_crit5",
    "category": "research",
    "voice": "Dean",
    "text": "Tier five research complete: Needle Storm. The swarm has learned to find every seam.",
    "file": "research_sw_crit5.mp3"
  },
  {
    "id": "top_tier_ballistic",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Kestrel Autocannon at maximum output. Deadeye Overwatch is online.",
    "file": "top_tier_ballistic.mp3"
  },
  {
    "id": "top_tier_thermal",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Pyre Lance at maximum output. Solar Pyre is online.",
    "file": "top_tier_thermal.mp3"
  },
  {
    "id": "top_tier_artillery",
    "category": "top_tier",
    "voice": "Dean",
    "text": "Mordant Howitzer at maximum output. Siegefall is ready to answer the line.",
    "file": "top_tier_artillery.mp3"
  },
  {
    "id": "top_tier_energy",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Helios Arc at maximum output. Singularity Lance is online.",
    "file": "top_tier_energy.mp3"
  },
  {
    "id": "top_tier_vulcan",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Cyclone Gatling at maximum output. Stormfeed is spinning up.",
    "file": "top_tier_vulcan.mp3"
  },
  {
    "id": "top_tier_sabre",
    "category": "top_tier",
    "voice": "Dean",
    "text": "Sabre Missile Battery at maximum output. Theatre Strike is cleared.",
    "file": "top_tier_sabre.mp3"
  },
  {
    "id": "top_tier_tesla",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Tesla Arc Coil at maximum output. Storm Lattice is live.",
    "file": "top_tier_tesla.mp3"
  },
  {
    "id": "top_tier_cryo",
    "category": "top_tier",
    "voice": "Mia",
    "text": "Cryo Flux Lance at maximum output. Whiteout Crown is online.",
    "file": "top_tier_cryo.mp3"
  },
  {
    "id": "top_tier_dronehive",
    "category": "top_tier",
    "voice": "Dean",
    "text": "Wasp Drone Hive at maximum output. Apogee Swarm is released.",
    "file": "top_tier_dronehive.mp3"
  },
  {
    "id": "combo_ballistic_pod_missile",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Skyfall Talon. Kestrel and missile pod are one hunting pattern.",
    "file": "combo_ballistic_pod_missile.mp3"
  },
  {
    "id": "combo_ballistic_pod_autocannon",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Twin Talon. Kestrel has doubled its close defence.",
    "file": "combo_ballistic_pod_autocannon.mp3"
  },
  {
    "id": "combo_ballistic_pod_laser",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Redline Lance. Kestrel has a laser sight through the dark.",
    "file": "combo_ballistic_pod_laser.mp3"
  },
  {
    "id": "combo_ballistic_pod_cluster",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Shrapnel Rain. Kestrel now saturates the approach.",
    "file": "combo_ballistic_pod_cluster.mp3"
  },
  {
    "id": "combo_ballistic_pod_uplink",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Hawk-Eye Lock. Kestrel sees the weak seam first.",
    "file": "combo_ballistic_pod_uplink.mp3"
  },
  {
    "id": "combo_thermal_pod_cryo",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Burning Ice. Pyre and Cryo now freeze what they burn.",
    "file": "combo_thermal_pod_cryo.mp3"
  },
  {
    "id": "combo_thermal_pod_frost",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Cinderfrost. Pyre fire meets a freezing mortar.",
    "file": "combo_thermal_pod_frost.mp3"
  },
  {
    "id": "combo_thermal_pod_plasma",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Sunfire Spear. Pyre and plasma are cutting one bright path.",
    "file": "combo_thermal_pod_plasma.mp3"
  },
  {
    "id": "combo_thermal_pod_missile",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Emberfall Salvo. Pyre is sending fire from the sky.",
    "file": "combo_thermal_pod_missile.mp3"
  },
  {
    "id": "combo_thermal_pod_shield",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Furnace Aegis. Pyre burns behind a wall of light.",
    "file": "combo_thermal_pod_shield.mp3"
  },
  {
    "id": "combo_artillery_pod_missile",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Thunder Payload. Mordant has guided fire on call.",
    "file": "combo_artillery_pod_missile.mp3"
  },
  {
    "id": "combo_artillery_pod_autocannon",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Close Quarters Siege. Mordant is no longer weak up close.",
    "file": "combo_artillery_pod_autocannon.mp3"
  },
  {
    "id": "combo_artillery_pod_cluster",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Iron Rain. Mordant will blanket the whole formation.",
    "file": "combo_artillery_pod_cluster.mp3"
  },
  {
    "id": "combo_artillery_pod_frost",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Winter Barrage. Mordant is freezing the kill zone.",
    "file": "combo_artillery_pod_frost.mp3"
  },
  {
    "id": "combo_artillery_pod_uplink",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Longshot Doctrine. Mordant can now reach the horizon.",
    "file": "combo_artillery_pod_uplink.mp3"
  },
  {
    "id": "combo_energy_pod_arc",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Arc Communion. Helios and lightning share one circuit.",
    "file": "combo_energy_pod_arc.mp3"
  },
  {
    "id": "combo_energy_pod_laser",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Prism Lance. Helios has found a second line through the target.",
    "file": "combo_energy_pod_laser.mp3"
  },
  {
    "id": "combo_energy_pod_plasma",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Starfire. Helios is burning through the armour from both sides.",
    "file": "combo_energy_pod_plasma.mp3"
  },
  {
    "id": "combo_energy_pod_uplink",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Lattice Sight. Helios targeting is now networked.",
    "file": "combo_energy_pod_uplink.mp3"
  },
  {
    "id": "combo_energy_pod_shield",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Aegis Circuit. Helios is protected and accelerating.",
    "file": "combo_energy_pod_shield.mp3"
  },
  {
    "id": "combo_vulcan_pod_missile",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Tornado Salvo. Cyclone is throwing missiles into the spin.",
    "file": "combo_vulcan_pod_missile.mp3"
  },
  {
    "id": "combo_vulcan_pod_salvo",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Cyclone Storm. Rotary fire and missile salvos converge.",
    "file": "combo_vulcan_pod_salvo.mp3"
  },
  {
    "id": "combo_vulcan_pod_autocannon",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Twin Tempest. Cyclone has become a storm of barrels.",
    "file": "combo_vulcan_pod_autocannon.mp3"
  },
  {
    "id": "combo_vulcan_pod_laser",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Red Cyclone. Rotary fire now carries a cutting beam.",
    "file": "combo_vulcan_pod_laser.mp3"
  },
  {
    "id": "combo_vulcan_pod_cluster",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Shredder Rain. Cyclone is feeding the lane with fragments.",
    "file": "combo_vulcan_pod_cluster.mp3"
  },
  {
    "id": "combo_vulcan_pod_uplink",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Gyro Lock. Cyclone tracking is fully stabilised.",
    "file": "combo_vulcan_pod_uplink.mp3"
  },
  {
    "id": "combo_sabre_pod_autocannon",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Gunmetal Wing. Sabre missiles have a close defence escort.",
    "file": "combo_sabre_pod_autocannon.mp3"
  },
  {
    "id": "combo_sabre_pod_missile",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Sabrefall. Sabre now carries a second guided rack.",
    "file": "combo_sabre_pod_missile.mp3"
  },
  {
    "id": "combo_sabre_pod_cluster",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Shard Salvo. Sabre is turning one lock into a field of impacts.",
    "file": "combo_sabre_pod_cluster.mp3"
  },
  {
    "id": "combo_sabre_pod_plasma",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Comet Burn. Sabre warheads now arrive hot.",
    "file": "combo_sabre_pod_plasma.mp3"
  },
  {
    "id": "combo_sabre_pod_uplink",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Hunter Vector. Sabre has a clearer path to every target.",
    "file": "combo_sabre_pod_uplink.mp3"
  },
  {
    "id": "combo_tesla_pod_arc",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Tempest Chain. Tesla arcs now have a second storm to follow.",
    "file": "combo_tesla_pod_arc.mp3"
  },
  {
    "id": "combo_tesla_pod_laser",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Lattice Beam. Tesla has a focused edge inside the chain.",
    "file": "combo_tesla_pod_laser.mp3"
  },
  {
    "id": "combo_tesla_pod_cryo",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Frozen Circuit. Tesla is slowing the targets it arcs.",
    "file": "combo_tesla_pod_cryo.mp3"
  },
  {
    "id": "combo_tesla_pod_uplink",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Arc Sight. Tesla chain targeting is now predictive.",
    "file": "combo_tesla_pod_uplink.mp3"
  },
  {
    "id": "combo_cryo_pod_cryo",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Whiteout Core. Cryo has built a second freezing field.",
    "file": "combo_cryo_pod_cryo.mp3"
  },
  {
    "id": "combo_cryo_pod_frost",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Absolute Zero. Cryo and Frost are locking the lane solid.",
    "file": "combo_cryo_pod_frost.mp3"
  },
  {
    "id": "combo_cryo_pod_plasma",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Thermal Shock. Cryo is cracking targets with heat and cold.",
    "file": "combo_cryo_pod_plasma.mp3"
  },
  {
    "id": "combo_cryo_pod_missile",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Frostfall Salvo. Cryo has guided fire for the frozen lane.",
    "file": "combo_cryo_pod_missile.mp3"
  },
  {
    "id": "combo_cryo_pod_shield",
    "category": "combo",
    "voice": "Mia",
    "text": "Symbiosis confirmed: Glacial Aegis. Cryo is holding the line behind hardlight.",
    "file": "combo_cryo_pod_shield.mp3"
  },
  {
    "id": "combo_dronehive_pod_autocannon",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Waspstorm. The hive has a rapid-fire escort.",
    "file": "combo_dronehive_pod_autocannon.mp3"
  },
  {
    "id": "combo_dronehive_pod_missile",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Hivefire. Wasp drones are carrying guided strike pods.",
    "file": "combo_dronehive_pod_missile.mp3"
  },
  {
    "id": "combo_dronehive_pod_cluster",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Bomblet Swarm. The hive is spreading explosives across the lane.",
    "file": "combo_dronehive_pod_cluster.mp3"
  },
  {
    "id": "combo_dronehive_pod_uplink",
    "category": "combo",
    "voice": "Dean",
    "text": "Symbiosis confirmed: Shared Eyes. Every wasp now sees the same target picture.",
    "file": "combo_dronehive_pod_uplink.mp3"
  },
  {
    "id": "chatty_normal",
    "category": "chatty",
    "voice": "Mia",
    "text": "Full comms restored. Good to be back in your ear, Commander.",
    "file": "chatty_normal.mp3"
  },
  {
    "id": "chatty_sparse",
    "category": "chatty",
    "voice": "Mia",
    "text": "Understood. I will pipe down a bit and only speak up when it counts.",
    "file": "chatty_sparse.mp3"
  },
  {
    "id": "chatty_warnings",
    "category": "chatty",
    "voice": "Mia",
    "text": "Warnings only, then. I will stay quiet unless you are about to lose the core.",
    "file": "chatty_warnings.mp3"
  },
  {
    "id": "chatty_off",
    "category": "chatty",
    "voice": "Mia",
    "text": "Going silent, Commander. I will be here if you need me.",
    "file": "chatty_off.mp3"
  }
];
